import React from 'react';
import { string, func } from 'prop-types';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { routingTip, routingTipTitle, routingTipClose } from './styles/styles.module.scss';

const RoutingTip = ({ tipType, onClose }) => {
  const routingTips = StringConstantsMixin.strings.TRACK_DETAIL.ROUTING_TIPS;
  return (
    <div className={routingTip}>
      <span className={routingTipTitle}>{routingTips[tipType]}</span>&nbsp;{routingTips[tipType + '_TEXT']}
      <button type="button" label={routingTips.TIP_BUTTON_LABEL} onClick={e => onClose(tipType, e)} className={routingTipClose} />
    </div>
  );
};

export default RoutingTip;

RoutingTip.propTypes = {
  onClose: func.isRequired,
  tipType: string.isRequired
};
